import TheOngoingExhibitPanel from "../TheOngoingExhibitPanel.vue";

export default {
  components: {
    TheOngoingExhibitPanel
  },

  data() {
    return{
      exhibitApi: "/web/api/exhibitions?status=ongoing",
      exhibits: {},
    }
  },

  created() {
    window.addEventListener("scroll", this.render, { once: true });
  },

  destroyed() {
    window.removeEventListener("scroll", this.render);
  },

  methods: {
    render() {
      axios.get(this.exhibitApi)
        .then(({ data: data }) => {
          this.exhibits = data;
        })
        .finally(() => (this.isLoading = false));
    },
  },
}
